export const universalRegExpChecker = (fieldName: string, value: string): any => {
  const templatesDictionary: { [key: string]: RegExp } = {
    email: /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.\w{1,3})+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/g,
    password: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/gm,
  };
  return templatesDictionary[fieldName].test(value);
};
